
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/ce054fac63dd830c93f1b099a98d2e3d.jpeg" 
          alt="Esfera Records Background" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-['Montserrat',sans-serif] text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Esfera Records
        </h1>
        <p className="font-['Poppins',sans-serif] text-xl sm:text-2xl lg:text-3xl text-white/95 mb-4 max-w-4xl mx-auto">
          Juntos al Éxito
        </p>
        <p className="font-['Poppins',sans-serif] text-base sm:text-lg text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Producción de eventos, artistas profesionales, grupos musicales, renta de sonido profesional y estudio de grabación. Hacemos realidad tus eventos con la mejor calidad y profesionalismo.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={scrollToContact}
            className="bg-gradient-to-r from-teal-600 to-teal-500 text-white px-8 py-4 rounded-full text-base font-semibold hover:from-teal-700 hover:to-teal-600 transition-all shadow-2xl whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            Solicita tu Evento
          </button>
          <button 
            onClick={() => {
              const element = document.getElementById('servicios');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/50 px-8 py-4 rounded-full text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver Servicios
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl w-10 h-10 flex items-center justify-center"></i>
      </div>
    </section>
  );
}
